@if (isFilial && isAdministrativo) {
  <p class="text-text-enabled">
    Período de testes expirado. Contate {{ referenciaMatriz }} para mais
    informações.
  </p>
} @else if (isAdministrativo) {
  <div class="flex flex-col gap-2 text-text-enabled">
    <p>
      Adquira o módulo saúde para sua corretora e continue oferecendo planos de
      saúde aos seus clientes.
    </p>
    <span
      class="font-semibold underline cursor-pointer text-text-interactive"
      (click)="trialService.openContratar()"
    >
      Contratar módulo
    </span>
  </div>
} @else {
  <p class="text-text-enabled">
    Período de testes expirado. Entre em contato com o administrador da sua
    corretora para mais informações.
  </p>
}
